/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  path {
    &.bg {
      fill: #AAFE00;
    }
    &.line {
      fill: #294A72;
    }
  }
`
export default class PopoverIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" css={Color}>
          <g id="그룹_5289" data-name="그룹 5289" transform="translate(-1998 -2333)">
            <path id="타원_471" className="bg" data-name="타원 471" d="M7,0A7,7,0,1,1,0,7,7,7,0,0,1,7,0Z" transform="translate(1998 2333)" fill="#aafe00"/>
            <path id="패스_4825" className="line" data-name="패스 4825" d="M26.408,693.6h1.667v7H26.408Z" transform="translate(1977.758 1644.042)" fill="#294a72"/>
            <path id="패스_4826" className="line" data-name="패스 4826" d="M26.408,686.729h1.667V688.4H26.408Z" transform="translate(1977.758 1648.625)" fill="#294a72"/>
          </g>
        </svg>
      </Fragment>
    )
  }
}
